export interface IconProps {
    size?: number | string;
    className?: string;
};

export const IconTriangle = ({ size = 18, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    return(
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
            >
            <svg width="100%" height="100%" viewBox="0 0 21 21">
                <polygon
                points="10.5,3 19,18 2,18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export const IconTrapeze = ({ size = 17, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    return(
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
            >
            <svg width="100%" height="100%" viewBox="0 0 21 21">
                <polygon
                points="4,20 20,20 17,4 7,4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};
export const IconRhombus = ({ size = 20, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    return(
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
            >
            <svg width="100%" height="100%" viewBox="0 0 21 21">
                <polygon
                points="10.5,2 18,9 10.5,19 3,9"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};
export const IconPentagon = ({ size = 20, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    return(
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
            >
            <svg width="100%" height="100%" viewBox="0 0 21 21">
                <polygon
                points="12,4 20,10 17,20 7,20 4,10"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export const IconHexagon = ({ size = 20, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    return(
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
            >
            <svg width="100%" height="100%" viewBox="0 0 22 22">
                <polygon
                points="6,3 16,3 21,11 16,19 6,19 1,11"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export const IconOctagon = ({ size = 18, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;
    return(
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
            >
            <svg width="100%" height="100%" viewBox="0 0 22 22">
                <polygon
                points="7,1 15,1 21,7 21,15 15,21 7,21 1,15 1,7"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export const IconDiamond = ({ size = 18, className = "" }: IconProps) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;

  return (
    <div
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: resolvedSize,
        height: resolvedSize,
        flexShrink: 0
      }}
    >
      <svg width="100%" height="100%" viewBox="0 0 24 24">
        {/* Outline */}
        <polygon
          points="3,9 7,3 17,3 21,9 12,21"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />

        {/* obere Facetten */}
        <line x1="3" y1="9" x2="7" y2="3" stroke="currentColor" strokeWidth="2"/>
        <line x1="7" y1="3" x2="12" y2="9" stroke="currentColor" strokeWidth="2"/>
        <line x1="17" y1="3" x2="12" y2="9" stroke="currentColor" strokeWidth="2"/>
        <line x1="21" y1="9" x2="17" y2="3" stroke="currentColor" strokeWidth="2"/>

        {/* untere Facetten */}
        <line x1="3" y1="9" x2="12" y2="9" stroke="currentColor" strokeWidth="2"/>
        <line x1="21" y1="9" x2="12" y2="9" stroke="currentColor" strokeWidth="2"/>
        <line x1="12" y1="9" x2="12" y2="21" stroke="currentColor" strokeWidth="2"/>
      </svg>
    </div>
  );
};

export const IconBorderWidth = ({ size = 20, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;

    return (
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
        >
            <svg width="100%" height="100%" viewBox="0 0 21 21">
                {/* 1px */}
                <line
                    x1="3"
                    y1="5"
                    x2="18"
                    y2="5"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                />
                {/* 2px */}
                <line
                    x1="3"
                    y1="9"
                    x2="18"
                    y2="9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                {/* 3px */}
                <line
                    x1="3"
                    y1="14"
                    x2="18"
                    y2="14"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
                {/* 4px */}
                <line
                    x1="3"
                    y1="19"
                    x2="18"
                    y2="19"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
};
export const IconSingleLine = ({ size = 18, className = "" }: IconProps) => {
    const resolvedSize = typeof size === "number" ? `${size}px` : size;

    return (
        <div
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: resolvedSize,
                height: resolvedSize
            }}
        >
            <svg width="100%" height="100%" viewBox="0 0 24 24">
                <line
                    x1="4"
                    y1="18"
                    x2="20"
                    y2="6"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
};